module.exports = __webpack_public_path__ + "img/img_ct.94dbab23.webp";